import React from 'react';
import { COMPANY, LOGO_URL, NAV_LINKS } from '../data/mockData';
import { Instagram, Mail, MapPin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt={COMPANY.name}
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your trusted partner for premium real estate in Bangalore.
              Experience unparalleled luxury with our exclusive collection of properties.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center text-gray-400 hover:border-[#DAA520] hover:text-[#DAA520] hover:bg-[#DAA520]/10 transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="w-10 h-10 rounded-full border border-gray-700 flex items-center justify-center text-gray-400 hover:border-[#DAA520] hover:text-[#DAA520] hover:bg-[#DAA520]/10 transition-all duration-300"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wider">QUICK LINKS</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-gray-400 text-sm hover:text-[#DAA520] transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Property Types */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wider">PROPERTY TYPES</h4>
            <ul className="space-y-3">
              <li><span className="text-gray-400 text-sm">Premium Plots</span></li>
              <li><span className="text-gray-400 text-sm">Luxury Apartments</span></li>
              <li><span className="text-gray-400 text-sm">Premium Villas</span></li>
              <li><span className="text-gray-400 text-sm">Commercial Spaces</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wider">CONTACT INFO</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#DAA520] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-gray-400 text-sm">Bangalore, Karnataka, India</p>
                  <a
                    href={COMPANY.mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#DAA520] text-xs hover:underline"
                  >
                    View on Map
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-[#DAA520] flex-shrink-0" />
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-gray-400 text-sm hover:text-[#DAA520] transition-colors"
                >
                  {COMPANY.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} livelong realty. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <button className="text-gray-500 text-sm hover:text-[#DAA520] transition-colors">Privacy Policy</button>
            <button className="text-gray-500 text-sm hover:text-[#DAA520] transition-colors">Terms of Service</button>
          </div>
        </div>
      </div>

      {/* Back to top */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 w-12 h-12 bg-[#DAA520] text-black rounded-full flex items-center justify-center shadow-lg hover:bg-[#C49B17] transition-all duration-300 z-40 hover:scale-110"
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
